import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";

function WelcomePage() {
  return (
    <div>
      <Navbar />
      <HeroSection />
    </div>
  );
}

export default WelcomePage;